import React from "react";

import styled from "styled-components/macro";

import ExtraSlotEntry from "./ExtraSlotEntry";

export default function ExtraSlotsWithoutNames({ users, signupItemID }) {
  const composeSlotsArray = () => {
    let slotsArray = [];

    const usersWithExtraSlots = users.filter(
      (u) => u.extraSlotsWithoutAdditionalNames
    );

    usersWithExtraSlots.forEach((user) => {
      const thisUsersSlots = new Array(
        user.extraSlotsWithoutAdditionalNames
      ).fill({
        signupItemID,
        connectedUserID: user.userID,
        newNumberOfSlotsAfterDelete: user.numberOfSlots - 1,
      });
      slotsArray = [...slotsArray, ...thisUsersSlots];
    });

    return slotsArray;
  };

  const slotsArray = composeSlotsArray();

  return (
    <Wrapper>
      {slotsArray?.map((slotDetails, i) => (
        <ExtraSlotEntry
          slot={slotDetails}
          key={i + slotDetails.newNumberOfSlotsAfterDelete}
        />
      ))}
    </Wrapper>
  );
}

const Wrapper = styled.div``;
